var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7034_926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25H4.125C3.62772 11.25 3.15081 11.0525 2.79917 10.7008C2.44754 10.3492 2.25 9.87228 2.25 9.375C2.25 8.87772 2.44754 8.40081 2.79917 8.04917C3.15081 7.69754 3.62772 7.5 4.125 7.5H4.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9V13.875C11.25 14.3723 11.0525 14.8492 10.7008 15.2008C10.3492 15.5525 9.87228 15.75 9.375 15.75C8.87772 15.75 8.40081 15.5525 8.04917 15.2008C7.69754 14.8492 7.5 14.3723 7.5 13.875V13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75H13.875C14.3723 6.75 14.8492 6.94754 15.2008 7.29917C15.5525 7.65081 15.75 8.12772 15.75 8.625C15.75 9.12228 15.5525 9.59919 15.2008 9.95083C14.8492 10.3025 14.3723 10.5 13.875 10.5H13.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9V4.125C6.75 3.62772 6.94754 3.15081 7.29917 2.79917C7.65081 2.44754 8.12772 2.25 8.625 2.25C9.12228 2.25 9.59919 2.44754 9.95083 2.79917C10.3025 3.15081 10.5 3.62772 10.5 4.125V4.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7034_926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiApp);
export default __webpack_public_path__ + "static/media/api-app.b5d2a9a73e45235c4a0828cb2847c519.svg";
export { ForwardRef as ReactComponent };